// import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import images from "../images";
// import banner from "../../Images/bg-3.png";
// // import { useNavigate } from "react-router-dom";

// const vehicleData = [
//   { id: 1, category: "HCV", subCategory: "Haulage", model: "TATA SIGNA 5530.S", tonnage: "28000 Kg", fuel: "Diesel", image: images.signa5530 },
//   { id: 2, category: "HCV", subCategory: "Haulage", model: "TATA SIGNA 4830.T", tonnage: "28000 Kg", fuel: "Diesel", image: images.signa4830 },
//   { id: 3, category: "HCV", subCategory: "Haulage", model: "TATA LPT 4830", tonnage: "28000 Kg", fuel: "Diesel", image: images.lpt4830 },
//   { id: 4, category: "HCV", subCategory: "Construck", model: "TATA SIGNA 4830.TK", tonnage: "28000 Kg", fuel: "Diesel", image: images.signa4830tk },
//   { id: 5, category: "HCV", subCategory: "Construck", model: "TATA SIGNA 3530.K", tonnage: "28000 Kg", fuel: "Diesel", image: images.signa3530tk },
//   { id: 6, category: "HCV", subCategory: "Construck", model: "TATA PRIMA 2830.TK", tonnage: "28000 Kg", fuel: "Diesel", image: images.signa2830tk },
//   { id: 7, category: "HCV", subCategory: "Construck", model: "TATA PRIMA 3530.TK", tonnage: "28000 Kg", fuel: "Diesel", image: images.signa2830k },
//   { id: 8, category: "ICV Trucks", subCategory: "LCV", model: "TATA ULTRA T.6", tonnage: "15 Ton", fuel: "Diesel", image: images.ultrat6 },
//   { id: 9, category: "ICV Trucks", subCategory: "LCV", model: "TATA ULTRA T.7", tonnage: "N/A", fuel: "Diesel", image: images.ultrat7 },
//   { id: 10, category: "ICV Trucks", subCategory: "LCV", model: "TATA LPT 712", tonnage: "5 Ton", fuel: "Diesel", image: images.lpt712 },
//   { id: 11, category: "ICV Trucks", subCategory: "LCV", model: "TATA 407 GOLD SFC", tonnage: "5 Ton", fuel: "Diesel", image: images.goldsfc },
//   { id: 12, category: "ICV Trucks", subCategory: "ICV", model: "TATA LPT 1216", tonnage: "15 Ton", fuel: "Diesel", image: images.lpt1216 },
//   { id: 13, category: "ICV Trucks", subCategory: "ICV", model: "TATA LPT 1112", tonnage: "N/A", fuel: "Diesel", image: images.lpt1112 },
//   { id: 14, category: "ICV Trucks", subCategory: "ICV", model: "TATA LPT 1212", tonnage: "5 Ton", fuel: "Diesel", image: images.lpt1212 },
//   { id: 15, category: "ICV Trucks", subCategory: "ICV", model: "TATA LPT 1616", tonnage: "5 Ton", fuel: "Diesel", image: images.lpt1616 },
//   { id: 16, category: "ICV Trucks", subCategory: "ICV", model: "TATA LPT 1816", tonnage: "5 Ton", fuel: "Diesel", image: images.lpt1816 },
//   { id: 17, category: "ICV Trucks", subCategory: "MCV", model: "TATA ULTRA T.19", tonnage: "15 Ton", fuel: "Diesel", image: images.ultrat19 },
//   { id: 18, category: "ICV Trucks", subCategory: "MCV", model: "TATA LPT 1912", tonnage: "N/A", fuel: "Diesel", image: images.lpt1912 },
//   { id: 19, category: "ICV Trucks", subCategory: "MCV", model: "TATA Signa 1923.K", tonnage: "5 Ton", fuel: "Diesel", image: images.signa1923 },
//   { id: 20, category: "ICV Trucks", subCategory: "MCV", model: "TATA LPT 1916", tonnage: "5 Ton", fuel: "Diesel", image: images.lpt1916 },
//   { id: 21, category: "ICV Trucks", subCategory: "MCV", model: "TATA LPT 1921", tonnage: "5 Ton", fuel: "Diesel", image: images.lpt1921 },
//   { id: 22, category: "Buses", subCategory: "Bus", model: "TATA LP 412", tonnage: "15 Ton", fuel: "Diesel", image: images.buslp412 },
//   { id: 23, category: "Buses", subCategory: "Bus", model: "TATA LP 712", tonnage: "N/A", fuel: "Diesel", image: images.buslp412 },
//   { id: 24, category: "Buses", subCategory: "Bus", model: "TATA LP 812", tonnage: "5 Ton", fuel: "Diesel", image: images.buslp412 },
//   { id: 25, category: "Buses", subCategory: "Bus", model: "TATA STARBUS PRIME 32", tonnage: "5 Ton", fuel: "Diesel", image: images.busprime32 },
//   { id: 26, category: "Buses", subCategory: "Bus", model: "TATA LP 412/36 Chassis", tonnage: "5 Ton", fuel: "Diesel", image: images.buslp41236 },
// ];

// const categoryOptions = {
//   "HCV": ["Haulage", "Construck"],
//   "ICV Trucks": ["LCV", "ICV", "MCV"],
//   "Buses": ["Bus"],
// };

// const FindVehicle = () => {
//   const [filters, setFilters] = useState({ category: "", subCategory: "", fuel: "" });
//   const [showVehicles, setShowVehicles] = useState(false);
//   const navigate = useNavigate();

//   const handleFilterChange = (key, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [key]: value,
//       ...(key === "category" ? { subCategory: "" } : {}),
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!filters.category || !filters.subCategory || !filters.fuel) {
//       alert("Please select all fields before submitting.");
//       return;
//     }
//     setShowVehicles(true);
//   };

//   const resetFilters = () => {
//     setFilters({ category: "", subCategory: "", fuel: "" });
//     setShowVehicles(false);
//   };

//   const filteredVehicles = vehicleData.filter(vehicle =>
//     vehicle.category === filters.category &&
//     vehicle.subCategory === filters.subCategory &&
//     vehicle.fuel === filters.fuel
//   );
  
//     const handleNavigation = (route) => {
//       navigate(route);
//     };
  

//   return (
//     <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 text-white py-12 px-4 sm:px-6 lg:px-8 rounded-lg">
//       <motion.div
//         initial={{ opacity: 0, y: -20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.5 }}
//         className="max-w-7xl mx-auto"
//       >
//         <div className="text-center mb-12">
//           <h2 className="text-4xl sm:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-blue-600 mb-4">
//             Find Your Ideal Vehicle
//           </h2>
//           <p className="text-lg text-gray-300 max-w-2xl mx-auto">
//             Discover the perfect commercial vehicle for your business needs
//           </p>
//         </div>

//         <motion.form
//           onSubmit={handleSubmit}
//           className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-gray-700 mb-12"
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ delay: 0.2 }}
//         >
//           <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//             <div className="space-y-2">
//               <label className="block text-sm font-medium text-gray-300">Category</label>
//               <select
//                 className="w-full px-4 py-3 rounded-lg bg-gray-700 border border-gray-600 text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
//                 value={filters.category}
//                 onChange={e => handleFilterChange("category", e.target.value)}
//               >
//                 <option value="">Select Category</option>
//                 {Object.keys(categoryOptions).map(cat => (
//                   <option key={cat} value={cat}>{cat}</option>
//                 ))}
//               </select>
//             </div>

//             <div className="space-y-2">
//               <label className="block text-sm font-medium text-gray-300">Sub-Category</label>
//               <select
//                 className="w-full px-4 py-3 rounded-lg bg-gray-700 border border-gray-600 text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition disabled:opacity-50"
//                 value={filters.subCategory}
//                 disabled={!filters.category}
//                 onChange={e => handleFilterChange("subCategory", e.target.value)}
//               >
//                 <option value="">Select Sub-Category</option>
//                 {filters.category && categoryOptions[filters.category].map(subCat => (
//                   <option key={subCat} value={subCat}>{subCat}</option>
//                 ))}
//               </select>
//             </div>

//             <div className="space-y-2">
//               <label className="block text-sm font-medium text-gray-300">Fuel Type</label>
//               <select
//                 className="w-full px-4 py-3 rounded-lg bg-gray-700 border border-gray-600 text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
//                 value={filters.fuel}
//                 onChange={e => handleFilterChange("fuel", e.target.value)}
//               >
//                 <option value="">Select Fuel Type</option>
//                 <option value="Diesel">Diesel</option>
//                 <option value="Electric">CNG</option>
//               </select>
//             </div>

//             <div className="flex items-end space-x-2">
//               <button
//                 type="submit"
//                 className="w-full px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-800 text-white font-medium rounded-lg hover:from-blue-700 hover:to-blue-900 transition-all shadow-lg hover:shadow-xl"
//               >
//                 Find Vehicles
//               </button>
//               {showVehicles && (
//                 <button
//                   type="button"
//                   onClick={resetFilters}
//                   className="px-4 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition"
//                 >
//                   Reset
//                 </button>
//               )}
//             </div>
//           </div>
//         </motion.form>

//         <AnimatePresence mode="wait">
//           {!showVehicles ? (
//             <motion.div
//               key="banner"
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               exit={{ opacity: 0 }}
//               transition={{ duration: 0.5 }}
//               className="flex justify-center"
//             >
//               <img
//                 src={banner}
//                 alt="Select options"
//                 className="w-full max-w-5xl h-auto rounded-xl shadow-2xl border border-gray-700"
//               />
//             </motion.div>
//           ) : filteredVehicles.length > 0 ? (
//             <motion.div
//               key="results"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               exit={{ opacity: 0, y: -20 }}
//               transition={{ duration: 0.5 }}
//             >
//               <div className="flex justify-between items-center mb-6">
//                 <h3 className="text-2xl font-semibold">
//                   {filteredVehicles.length} Vehicles Found
//                 </h3>
//               </div>

//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//                 {filteredVehicles.map((vehicle) => (
//                   <motion.div
//                     key={vehicle.id}
//                     whileHover={{ y: -5 }}
//                     className="bg-gray-800 rounded-xl overflow-hidden shadow-lg border border-gray-700 cursor-pointer group"
//                     // onClick={() => navigate(`/vehicle/${vehicle.id}`)}
//                   >
//                     <div className="relative h-48 overflow-hidden">
//                       <img
//                         src={vehicle.image}
//                         alt={vehicle.model}
//                         className="w-full h-full  object-fill transition-transform duration-500 group-hover:scale-105"
//                       />
//                       <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
//                     </div>
//                     <div className="p-5">
//                       <h3 className="text-xl font-bold mb-1">{vehicle.model}</h3>
//                       <div className="flex flex-wrap gap-2 mt-3">
//                         <span className="px-3 py-1 bg-blue-900/30 text-blue-400 rounded-full text-xs font-medium">
//                           {vehicle.category}
//                         </span>
//                         <span className="px-3 py-1 bg-gray-700 text-gray-300 rounded-full text-xs font-medium">
//                           {vehicle.subCategory}
//                         </span>
//                         <span className="px-3 py-1 bg-green-900/30 text-green-400 rounded-full text-xs font-medium">
//                           {vehicle.fuel}
//                         </span>
//                       </div>
//                       <div className="mt-4 flex justify-between items-center">
//                         {/* <span className="text-gray-400">{vehicle.tonnage}</span> */}
//                        <a href="/heavy-commercial-vehicles#hcv">
//                        <button  className="text-white  flex items-center bg-gradient-to-r from-blue-600 to-blue-800">
//                           View Details
                          
//                           <svg
//                             className="w-4 h-4 ml-1"
//                             fill="none"
//                             stroke="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth={2}
//                               d="M14 5l7 7m0 0l-7 7m7-7H3"
//                             />
//                           </svg>
//                         </button>
//                        </a>
//                       </div>
//                     </div>
//                   </motion.div>
//                 ))}
//               </div>
//             </motion.div>
//           ) : (
//             <motion.div
//               key="no-results"
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               exit={{ opacity: 0 }}
//               className="text-center py-12"
//             >
//               <div className="bg-gray-800/50 rounded-xl p-8 max-w-md mx-auto border border-gray-700">
//                 <svg
//                   className="w-16 h-16 text-red-400 mx-auto mb-4"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={1.5}
//                     d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//                   />
//                 </svg>
//                 <h3 className="text-xl font-semibold mb-2">No Vehicles Found</h3>
//                 <p className="text-gray-400 mb-4">
//                   We couldn't find any vehicles matching your criteria.
//                 </p>
//                 <button
//                   onClick={resetFilters}
//                   className="px-6 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg transition"
//                 >
//                   Try Different Filters
//                 </button>
//               </div>
//             </motion.div>
//           )}
//         </AnimatePresence>
//       </motion.div>
//     </div>
//   );
// };

// export default FindVehicle;
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import banner from "../../Images/bg-3.png";
import images from "../images"; // placeholder


// const API_BASE_URL = 'http://localhost:5000/api'

// const API_BASE = "http://localhost:5000/api/vehicles"; // Update for production
const API_BASE = 'https://japl-backend.onrender.com/api/vehicles'

const categoryOptions = {
  HCV: ["Haulage", "Construck"],
  "ICV Trucks": ["LCV", "ICV", "MCV"],
  Buses: ["Bus"],
};

const FindVehicle = () => {
  const [filters, setFilters] = useState({
    category: "",
    subCategory: "",
    fuel: "",
  });
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showVehicles, setShowVehicles] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
      ...(key === "category" ? { subCategory: "" } : {}),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowVehicles(false);
    setError("");
    setVehicles([]);

    if (!filters.category || !filters.subCategory || !filters.fuel) {
      setError("Please select all fields before submitting.");
      return;
    }

    setLoading(true);
    try {
      const params = {
        category: filters.category,
        subCategory: filters.subCategory,
        fuel: filters.fuel,
      };
      const response = await axios.get(API_BASE, { params });
      setVehicles(response.data || []);
      setShowVehicles(true);
    } catch (err) {
      setError("Error fetching vehicles. Please try again.");
      setVehicles([]);
      setShowVehicles(false);
    } finally {
      setLoading(false);
    }
  };

  const resetFilters = () => {
    setFilters({ category: "", subCategory: "", fuel: "" });
    setVehicles([]);
    setShowVehicles(false);
    setError("");
  };

  const handleCardClick = (id) => {
    // If all detail pages are under /mhcv/vehicles/:id
    navigate(`/mhcv/vehicles/${id}`);
  };

  // Handy helpers for extracting nested fields
  const getCategory = (v) =>
    v?.detailedSpecs?.["Vehicle Information"]?.["Product Category"] || "N/A";
  const getFuel = (v) =>
    v?.detailedSpecs?.Performance?.["Fuel Type"] || "N/A";

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 text-white py-12 px-4 sm:px-6 lg:px-8 rounded-lg">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-7xl mx-auto"
      >
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-blue-600 mb-4">
            Find Your Ideal Vehicle
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Discover the perfect commercial vehicle for your business needs
          </p>
        </div>

        <motion.form
          onSubmit={handleSubmit}
          className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-gray-700 mb-12"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-300">
                Category
              </label>
              <select
                className="w-full px-4 py-3 rounded-lg bg-gray-700 border border-gray-600 text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                value={filters.category}
                onChange={(e) => handleFilterChange("category", e.target.value)}
              >
                <option value="">Select Category</option>
                {Object.keys(categoryOptions).map((cat) => (
                  <option key={cat} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-300">
                Sub-Category
              </label>
              <select
                className="w-full px-4 py-3 rounded-lg bg-gray-700 border border-gray-600 text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition disabled:opacity-50"
                value={filters.subCategory}
                disabled={!filters.category}
                onChange={(e) => handleFilterChange("subCategory", e.target.value)}
              >
                <option value="">Select Sub-Category</option>
                {filters.category &&
                  categoryOptions[filters.category].map((subCat) => (
                    <option key={subCat} value={subCat}>
                      {subCat}
                    </option>
                  ))}
              </select>
            </div>

            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-300">
                Fuel Type
              </label>
              <select
                className="w-full px-4 py-3 rounded-lg bg-gray-700 border border-gray-600 text-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                value={filters.fuel}
                onChange={(e) => handleFilterChange("fuel", e.target.value)}
              >
                <option value="">Select Fuel Type</option>
                <option value="Diesel">Diesel</option>
                <option value="CNG">CNG</option>
              </select>
            </div>

            <div className="flex items-end space-x-2">
              <button
                type="submit"
                className="w-full px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-800 text-white font-medium rounded-lg hover:from-blue-700 hover:to-blue-900 transition-all shadow-lg hover:shadow-xl"
                disabled={loading}
              >
                {loading ? "Loading..." : "Find Vehicles"}
              </button>
              {showVehicles && (
                <button
                  type="button"
                  onClick={resetFilters}
                  className="px-4 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition"
                >
                  Reset
                </button>
              )}
            </div>
          </div>
        </motion.form>

        {error && (
          <div className="text-red-400 text-center mb-6 font-semibold">{error}</div>
        )}

        <AnimatePresence mode="wait">
          {!showVehicles ? (
            <motion.div
              key="banner"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
              className="flex justify-center"
            >
              <img
                src={banner}
                alt="Select options"
                className="w-full max-w-5xl h-auto rounded-xl shadow-2xl border border-gray-700"
              />
            </motion.div>
          ) : vehicles.length > 0 ? (
            <motion.div
              key="results"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5 }}
            >
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-semibold">{vehicles.length} Vehicles Found</h3>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {vehicles.map((vehicle) => (
                  <motion.div
                    key={vehicle._id}
                    whileHover={{ y: -5 }}
                    className="bg-gray-800 rounded-xl overflow-hidden shadow-lg border border-gray-700 cursor-pointer group"
                    onClick={() => handleCardClick(vehicle._id)}
                  >
                    <div className="relative h-48 overflow-hidden">
                      <img
                        src={
                          (vehicle.images && vehicle.images[0]) ||
                          images.placeholderImage
                        }
                        alt={vehicle.name || "Vehicle"}
                        className="w-full h-full object-fill transition-transform duration-500 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                    </div>
                    <div className="p-5">
                      <h3 className="text-xl font-bold mb-1">{vehicle.name || "Unknown Vehicle"}</h3>
                      <div className="flex flex-wrap gap-2 mt-3">
                        <span className="px-3 py-1 bg-blue-900/30 text-blue-400 rounded-full text-xs font-medium">
                          {getCategory(vehicle)}
                        </span>
                        <span className="px-3 py-1 bg-green-900/30 text-green-400 rounded-full text-xs font-medium">
                          {getFuel(vehicle)}
                        </span>
                      </div>
                      <div className="mt-4 flex justify-between items-center">
                        <button
                          onClick={e => {
                            e.stopPropagation();
                            handleCardClick(vehicle._id);
                          }}
                          className="text-white flex items-center bg-gradient-to-r from-blue-600 to-blue-800 px-4 py-2 rounded"
                        >
                          View Details
                          <svg
                            className="w-4 h-4 ml-1"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M14 5l7 7m0 0l-7 7m7-7H3"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          ) : (
            <motion.div
              key="no-results"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="text-center py-12"
            >
              <div className="bg-gray-800/50 rounded-xl p-8 max-w-md mx-auto border border-gray-700">
                <svg
                  className="w-16 h-16 text-red-400 mx-auto mb-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <h3 className="text-xl font-semibold mb-2">No Vehicles Found</h3>
                <p className="text-gray-400 mb-4">
                  We couldn't find any vehicles matching your criteria.
                </p>
                <button
                  onClick={resetFilters}
                  className="px-6 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg transition"
                >
                  Try Different Filters
                </button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </div>
  );
};

export default FindVehicle;
